export const DOWNTIME_TABLE_HEADERS = ["Capsule", "Downtime Branch", ""];
